import { Grid } from './SimpleGridLight';
import { classNames, SortOrder } from './Settings';
import { GridColumn } from './GridColumn';
import { GridRow } from './GridRow';
import { GridRender } from './GridRender';
import { comparers } from '@Common/Helpers/Comparers';

export class SortManager {
    private _grid: Grid;
    private _render: GridRender;
    private _orderedRows: GridRow[];
    private _sortColumn: GridColumn;

    constructor(grid: Grid, render: GridRender) {
        this._grid = grid;
        this._render = render;
    }

    private onSortingHandler: () => void = $.noop;

    public onSorting(fn: () => void) {
        this.onSortingHandler = fn;
    }

    public init() {
        for (const gridColumn of this._grid.columns()) {
            const jCol = gridColumn.tableColumn();
            if (gridColumn.isSortable()) {
                jCol.on('click', (eventObject: JQuery.Event) => {
                    if (gridColumn.isSortable()) {
                        this.sortHandler(gridColumn);
                    }
                });

                jCol.on('mouseup', (eventObject: JQuery.Event) => {
                    if (eventObject.button === 2 && this._sortColumn == gridColumn) {
                        gridColumn.sortOrder(SortOrder.None);
                        this.sort(gridColumn);
                        this._sortColumn = null;
                        this._grid.refresh();
                    }
                });
            }
            if (this._sortColumn == null && gridColumn.sortOrder() != SortOrder.None) {
                this._sortColumn = gridColumn;
            }
        }
    }

    private sortHandler(gridColumn: GridColumn) {
        const newSortOrder: SortOrder = gridColumn.sortOrder() == 0 ? 1 : -gridColumn.sortOrder();
        if (this._sortColumn != null) {
            this._sortColumn.sortOrder(SortOrder.None);
        }
        gridColumn.sortOrder(newSortOrder);
        this.onSortingHandler();
        this.sort(gridColumn);
        this._grid.refresh();
    }

    public static getSortClassName(order: SortOrder): string {
        switch (order) {
            case SortOrder.Asc:
                return classNames.sortAsc;
            case SortOrder.Desc:
                return classNames.sortDesc;
        }
        return '';
    }

    private sort(gridColumn: GridColumn) {
        const comparer = this.getComparer(gridColumn);

        const rowValueCache = {};
        const readChached = (row: GridRow) => {
            if (rowValueCache.hasOwnProperty(row.dataIndex().toString())) {
                return rowValueCache[row.dataIndex()];
            }
            return (rowValueCache[row.dataIndex()] = row.getValue(gridColumn));
        };
        const pinnedRows = [];
        this._orderedRows = [];

        for (const row of this._grid.rows()) {
            if (row.isPinned) {
                pinnedRows.push(row);
            } else {
                this._orderedRows.push(row);
            }
        }

        this._orderedRows.sort((row1: GridRow, row2: GridRow) => {
            return comparer(readChached(row1), readChached(row2));
        });
        this._orderedRows.push(...pinnedRows);

        this._sortColumn = gridColumn;
    }

    private getComparer(gridColumn: GridColumn): (x, u) => number {
        let comparer: (x, u) => number;

        if (gridColumn.getComparer() != null) {
            comparer = gridColumn.getComparer();
        } else {
            comparer = comparers.comparer;
        }

        if (gridColumn.sortOrder() == SortOrder.Desc) {
            return (x, u) => {
                return comparer(u, x);
            };
        } else if (gridColumn.sortOrder() == SortOrder.None) {
            return (x, u) => {
                return 0;
            };
        }
        return comparer;
    }

    public resort() {
        if (this._sortColumn != null) {
            this.sort(this._sortColumn);
        } else {
            this._orderedRows = this._grid.rows();
        }
    }

    public getOrderedIndex(dataIndex: number): number {
        return dataIndex;
    }

    public getIndex(): GridRow[] {
        return this._orderedRows;
    }

    public changeData(gridRow: GridRow, gridColumn: GridColumn) {
        if (gridColumn == null || this._sortColumn === gridColumn) {
            this.resort();
        }
    }
}
